import { render, staticRenderFns } from "./ManageVehicles.vue?vue&type=template&id=bb7196d2&scoped=true"
import script from "./ManageVehicles.vue?vue&type=script&lang=js"
export * from "./ManageVehicles.vue?vue&type=script&lang=js"
import style0 from "./ManageVehicles.vue?vue&type=style&index=0&id=bb7196d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7196d2",
  null
  
)

export default component.exports